import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ArrowButton from "../ArrowButton";
import PrizeCard from "../PrizeCard";
import ActivityCard from "@components/ActivityCard";
import "./style.scss";

import "swiper/css";
import "swiper/css/navigation";
import AppVideoCard from "../AppVideoCard";

export default function PrizeSlider({ prizesToRender = [] }) {
  return (
    <div className="ultra-insider-slider">
      <div className="slider">
        <div className="cta-group">
          <div className="swiper-button-prev prize">
            <ArrowButton reverse />
          </div>
          <div className="swiper-button-next prize">
            <ArrowButton />
          </div>
        </div>
        <Swiper
          className="premiumSwiper-prize"
          modules={[Navigation]}
          spaceBetween={28}
          slidesPerView={1.1}
          navigation={{
            nextEl: ".swiper-button-next.prize",
            prevEl: ".swiper-button-prev.prize",
          }}
          breakpoints={{
            720: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },
          }}
        >
          {prizesToRender.map((e, idx) => {
            if (e.ident === "app-video-placeholder") {
              return (
                <SwiperSlide key={idx}>
                  <AppVideoCard
                    mobileImg={e?.thumbnail?.file?.url}
                    desktopImg={e?.hero_image?.file?.url}
                    imgDesc={e?.hero_image?.metadata?.imgDesc}
                    copy={e?.content?.title}
                    points={e.price}
                    brands={e.brands}
                    completed={e.completed}
                    ident={e.ident}
                    type={e.type}
                    highlighted={e.highlighted}
                    disabled={e.disabled}
                    date={e?.date}
                    description={e.content?.description || ""}
                  />
                </SwiperSlide>
              );
            }

            return (
              <SwiperSlide key={idx}>
                <PrizeCard
                  brands={e.brands}
                  copy={e.content?.title}
                  mobileImg={e.thumbnail?.file?.url}
                  desktopImg={e.hero_image?.file?.url}
                  imgDesc={e.hero_image?.metadata?.imgDesc}
                  highlighted={e.highlighted}
                  points={e.price}
                  key={idx}
                  availableForStatus={e.hasLevel}
                  ident={e.ident}
                  level={e.level}
                  inStock={e.inStock}
                  hasPoints={e.hasPoints}
                  hasLevel={e.hasLevel}
                  partner={e.partner}
                  completed={e.completed || false}
                  href={e.ident}
                  date={e.date || null}
                  description={e.content?.description || ""}
                  disabled={e.disabled || false}
                  list={e.list || false}
                  buttonCopy={e.buttonCopy || false}
                  to={e.to || false}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
